import React from 'react';
import { getSegmentLabel } from '../labelGetters';

export default function SegmentDisplay({ segment, labels, isNew = false }) {
  const segmentId = segment.experienceSegmentId || segment.id;
  const displayName =
    getSegmentLabel(segmentId, labels) || `Segment #${segmentId}`;
  const borderClass = isNew ? 'border-green-300' : 'border-gray-200';

  return (
    <div
      className={`flex items-center gap-2 p-2 bg-gray-50 rounded border ${borderClass}`}
    >
      <i className="fa-regular fa-users text-teal-500" />
      <span className="text-sm text-gray-700">{displayName}</span>
    </div>
  );
}
